const makeInitialState = data => ({
  id: data ? data.id : '',
  name: data ? data.name : ''
});

export default makeInitialState;
